import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from "@medsurf/flat-facades";
import { ZodSharedValidator } from '@medsurf/flat-validators';

@Component({
    selector: 'medsurf-code-editor-marker',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './annotation-editor-dialog.component.html',
    styleUrls: ['./annotation-editor-dialog.component.scss'],
    standalone: false
})
export class AnnotationEditorDialogComponent {
  #annotationLinkEditorDialog: FlatModels.EditorAuthorModels.AnnotationLinkEditorDialog;
  linkForm = new FormGroup(
    {
      layer: new FormControl(''),
      image: new FormControl(''),
      group: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.EditorAuthorModels.AnnotationEditorDialogSchema
      ),
      updateOn: 'change',
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public ref: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.#annotationLinkEditorDialog = structuredClone(this.dynamicDialogConfig.data);
    
    // Patch Data
    if ((this.#annotationLinkEditorDialog.linkText || '').includes(',')) {
      const [layer, image, group] = this.#annotationLinkEditorDialog.linkText.split(',');
      this.linkForm.reset({
        layer,
        image,
        group
      });
    } else {
      this.linkForm.reset({
        group: this.#annotationLinkEditorDialog.linkText
      });
    }
  }
  
  onSubmit() {
    if (this.linkForm.invalid) {
      return;
    }
    
    // Return Values
    this.ref.close({
      linkText: `${this.linkForm.value.layer},${this.linkForm.value.image},${this.linkForm.value.group}`
    });
  }
}
